import { OpenPositionFragment } from 'generated/resources/graphql'

export interface OpenPositionsGroupInterface {
  [key: string]: OpenPositionFragment[]
}

export const useOpenPositionsGroups = (positions: OpenPositionFragment[]) =>
  positions.reduce((acc: OpenPositionsGroupInterface, position) => {
    const key = position.location?.city || 'noLocation'
    acc[key] = acc[key] || []
    acc[key].push(position)
    return acc
  }, {})
